import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { msg } from "@omegagrid/localize";
import { ColorTypes } from "@omegagrid/core";
import rp, { BaseSidebar, Browser, BrowserEvent } from "@reporting/rp-app-host";
import { AIApplication, ChatList } from "..";
import { ChatBrowserAdapter } from "../adapters";
import { style } from "./sidebar.style";

@customElement('rp-mf-ai-sidebar')
export class Sidebar extends BaseSidebar<AIApplication> {

	static styles = [...BaseSidebar.styles, style];

	static reactiveState = true;
	
	constructor() {
		super();
		this.setState({
			activeTab: 'filters',
			components: {}
		});
	}

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: ChatBrowserAdapter;
    get browserAdapter() { 
        if (!this._browserAdapter) {
            this._browserAdapter = new ChatBrowserAdapter();
        }
        return this._browserAdapter;
    }

	layout() {
		this.browser?.layout();
	}

	_onBrowserSelect = (e: BrowserEvent) => {
		const chunks = e.node.key.split('-');
		rp.host.open(`ai-chat-${e.node.key}`, {title: `Chat #${chunks[0]}`, preventDisconnect: true});
	};

	newChat() {
		rp.applications.get<AIApplication>('ai').newChat();
	}

	refresh = () => this.browser.refresh();

	toggleCollapse = () => this.browser.tree?.toggleTreeCollapse();

	render = () => html`
		<div class="head">
			<og-bucket-button
				text="${msg('New chat')}"
				icon="comment-plus"
				@click="${() => this.newChat()}">
			</og-bucket-button>
		</div>
		<div class="controls">
			<og-button
				icon="arrows-rotate"
				title="${msg('Refresh')}"
				color="${ColorTypes.Transparent}"
				@click="${() => this.refresh()}">
			</og-button>

			<og-button
				icon="square-plus"
				color="transparent"
				title="${msg('Collapse/Expand tree')}"
				@click="${() => this.toggleCollapse()}">
			</og-button>
		</div>

		<div class="body">
			<rp-browser .adapter="${this.browserAdapter}" @browser.select="${this._onBrowserSelect}"></rp-browser>
		</div>
	`;

}
